var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"interval"},[(_vm.label)?_c('div',{staticClass:"interval-label main-text-color"},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.label))+"\n    ")]):_vm._e(),_c('el-time-select',{staticClass:"interval-time-select",attrs:{"value":_vm.inputValue,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"picker-options":{
            start: '00:00',
            step: '00:15',
            end: '23:45'
        }},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }